import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { useAuth } from '@/hooks/useAuth'
import { useOrpcTanstackQueryUtils } from '../orpc'

// Check onboarding status (only runs when signed in)
export function useOnboardingStatus() {
  const { isSignedIn } = useAuth()
  const orpc = useOrpcTanstackQueryUtils()
  return useQuery({
    ...orpc.onboarding.checkStatus.queryOptions(),
    enabled: !!isSignedIn,
  })
}

// Complete onboarding (mark company.onboardingComplete = true)
export function useCompleteOnboarding() {
  const orpc = useOrpcTanstackQueryUtils()
  const queryClient = useQueryClient()

  return useMutation(
    orpc.onboarding.completeOnboarding.mutationOptions({
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: orpc.onboarding.key() })
        queryClient.invalidateQueries({ queryKey: orpc.company.key() })
      },
    })
  )
}

// Complete quickstart (mark as done or skipped)
export function useCompleteQuickStart() {
  const orpc = useOrpcTanstackQueryUtils()
  const queryClient = useQueryClient()

  return useMutation(
    orpc.onboarding.completeQuickStart.mutationOptions({
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: orpc.onboarding.key() })
        queryClient.invalidateQueries({ queryKey: orpc.company.key() })
      },
    })
  )
}

// Mark owner onboarding as complete (skipped or finished the admin onboarding flow)
export function useCompleteOwnerOnboarding() {
  const orpc = useOrpcTanstackQueryUtils()
  const queryClient = useQueryClient()

  return useMutation(
    orpc.onboarding.completeOwnerOnboarding.mutationOptions({
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: orpc.onboarding.key() })
        queryClient.invalidateQueries({ queryKey: orpc.company.key() })
      },
    })
  )
}

// Get quick start progress
export function useQuickStartProgress() {
  const { isSignedIn } = useAuth()
  const orpc = useOrpcTanstackQueryUtils()
  return useQuery({
    ...orpc.onboarding.getQuickStartProgress.queryOptions(),
    enabled: !!isSignedIn,
  })
}

// Save owner first/last name + company name (in-app owner-details quickstart step)
export function useUpdateOwnerDetails() {
  const orpc = useOrpcTanstackQueryUtils()
  const queryClient = useQueryClient()

  return useMutation(
    orpc.onboarding.updateOwnerDetails.mutationOptions({
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: orpc.onboarding.key() })
        queryClient.invalidateQueries({ queryKey: orpc.company.key() })
      },
    })
  )
}
